import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
import store from "@/store";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      component: Home
    },
    {
      path: "*",
      component: Home
    },
    {
      path: "/reports/create",
      name: "report-create",
      meta: {
        requiresAuth: true
      },
      component: () =>
        import(/* webpackChunkName: "report-create" */ "./views/CreateReport.vue")
    },
    {
      path: "/reports/history",
      name: "report-history",
      meta: {
        requiresAuth: true
      },
      component: () =>
        import(/* webpackChunkName: "report-history" */ "./views/ReportHistory.vue")
    },
    {
      path: "/back-office",
      name: "back-office",
      meta: {
        requiresAuth: true
      },
      component: () =>
        import(/* webpackChunkName: "back-office" */ "./views/BackOffice/BackOffice.vue")
    },
    {
      path: "/back-office/user/:id([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})",
      name: "edit-user",
      meta: {
        requiresAuth: true
      },
      component: () =>
        import(/* webpackChunkName: "edit-user" */ "./views/BackOffice/EditUser.vue")
    },
    {
      path: "/back-office/user/add",
      name: "add-user",
      meta: {
        requiresAuth: true
      },
      component: () =>
        import(/* webpackChunkName: "add-user" */ "./views/BackOffice/AddUser.vue")
    },
    {
      path: "/account/:id([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})/password-reset/:token",
      name: "password-reset",
      meta: {
        requiresAuth: false
      },
      component: () =>
        import(/* webpackChunkName: "password-reset" */ "./views/PasswordReset.vue")
    },
    {
      path: "/account/edit",
      name: "user-account",
      meta: {
        requiresAuth: true
      },
      component: () =>
        import(/* webpackChunkName: "user-account" */ "./views/UserAccount.vue")
    },
    {
      path: "/frequently-asked-questions",
      name: "faq",
      meta: {
        requiresAuth: false
      },
      component: () =>
        import(/* webpackChunkName: "faq" */ "./views/FAQ.vue")
    },
    {
      path: "/terms-and-conditions",
      name: "terms-and-conditions",
      meta: {
        requiresAuth: false
      },
      component: () =>
        import(/* webpackChunkName: "terms-and-conditions" */ "./views/Terms.vue")
    },
    {
      path: "/privacy-policy",
      name: "privacy-policy",
      meta: {
        requiresAuth: false
      },
      component: () =>
        import(/* webpackChunkName: "privacy-policy" */ "./views/Privacy.vue")
    },
    {
      path: "/contact-us",
      name: "contact-us",
      meta: {
        requiresAuth: false
      },
      component: () =>
        import(/* webpackChunkName: "contact-us" */ "./views/ContactUs.vue")
    },
    {
      path: "/user-guide",
      name: "user-guide",
      meta: {
        requiresAuth: false
      },
      component: () =>
        import(/* webpackChunkName: "user-guide" */ "./views/UserGuide.vue")
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return {
        selector: to.hash,
        offset: { x: 0, y: 10 }
      };
    } else {
      return { x: 0, y: 0 }
    }
  }
});

// Authentication Barrier Check
router.beforeEach(async (to, from, next) => {
  // Before each router call, check whether the route meta has requireAuth barrier:
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (Vue.prototype.$auth.isAuthenticated()) {
      next();
    } else {
      store.dispatch("logout");
      next({
        path: "/"
      });
    }
  } else {
    next();
  }
});

export default router;
